import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Autocomplete } from '../../autocomplete';
import { getIcon } from '../../icon';
import { Markdown } from '../../markdown';
import { MenuItemSection } from '../../menu';
import { TextField } from '../../textfield';
import { Typography } from '../../typography';
import { reactElementSerializer } from '../../utils';
const normalize = (value) => {
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
};
const escapeRegExp = (value) => {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
const NavSearchImpl = (props) => {
    const [inputValue, setInputValue] = React.useState('');
    const Icon = props.startAdornmentIcon
        ? getIcon(props.startAdornmentIcon)
        : undefined;
    return (_jsx(Autocomplete, { value: null, options: props.options, placeholder: props.placeholder, noOptionsText: props.noOptionsText, slotProps: {
            input: {
                startAdornment: Icon ? _jsx(Icon, { fontSize: "small" }) : undefined
            }
        }, renderInput: (params) => (_jsx(TextField, { ...params, placeholder: props.placeholder, slotProps: {
                ...params.slotProps,
                input: {
                    ...params.slotProps.input,
                    startAdornment: Icon ? (_jsx(Icon, { fontSize: "small" })) : undefined
                },
                htmlInput: {
                    ...params.slotProps.htmlInput,
                    'aria-label': props.placeholder
                }
            } })), inputValue: inputValue, open: inputValue.length > 0, openOnFocus: false, forcePopupIcon: false, groupBy: (option) => option.type ?? '', getOptionKey: (option) => `${JSON.stringify(option.label, reactElementSerializer)}-${option.value}`, renderGroup: (params) => (_jsxs("div", { children: [_jsx(MenuItemSection, { children: params.group }), _jsx("ul", { style: { padding: 0 }, children: params.children })] }, params.key)), filterOptions: (options, params) => {
            return options.filter((option) => {
                const label = normalize(JSON.stringify(option.label, reactElementSerializer));
                const type = normalize(String(option.type));
                const searchValue = normalize(params.inputValue);
                return (label.includes(searchValue) ||
                    (!props.excludeSearchByType &&
                        type.includes(searchValue)));
            });
        }, renderOption: (liProps, option, state) => (_jsx("li", { ...liProps, children: _jsx(Typography, { component: "span", sx: {
                    fontSize: (theme) => theme.components?.menu?.['item-default']
                        ?.fontSize,
                    fontWeight: (theme) => theme.components?.menu?.['item-default']
                        ?.fontWeight
                }, children: typeof option.label === 'string' ? (_jsx(Markdown, { children: option.label.replace(new RegExp(escapeRegExp(state.inputValue), 'i'), ($1) => $1.replace(/^(\s*)(.*?)(\s*)$/, '$1**$2**$3')) })) : (option.label) }) })), sx: {
            '.MuiInputBase-root .MuiOutlinedInput-notchedOutline': {
                borderColor: (theme) => theme.palette.divider
            }
        }, onInput: (event) => {
            setInputValue(event.target.value);
        }, onBlur: () => setInputValue(''), onChange: (value) => {
            if (value) {
                props.onSelect?.(value);
                setInputValue('');
            }
        } }));
};
export const NavSearch = NavSearchImpl;
